import { IonButton, IonCol, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonModal, IonRow, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import Header from '../../components/Header/Header';
import { onScroll } from '../../services/sticky-menu.service';
import Footer from '../../components/Footer';
import { useRef } from 'react';
import { localCategories } from '../../services/products/all-category.service';
import { useParams } from 'react-router';
import { appSubDir } from '../../configs/app';
import { arrowUp } from 'ionicons/icons';
import ProductGridWithPagination from '../../components/Products/ProductGridWithPagination';
import { trackPageView } from '../../functions/analytics.functions';

type CustomParam = {
    cat: string
    subCat: string
}
const SubCategory: React.FC = () => {
    const { cat, subCat } = useParams() as CustomParam
    const categories = localCategories()
    const category = categories.find((item) => item.title === cat)
    const modal = useRef<HTMLIonModalElement>(null)
    useIonViewDidEnter(() => {
        trackPageView(subCat + " | Sub Category")
    })
    return (
        <IonContent fullscreen scrollEvents={true} onIonScroll={onScroll}>
            <Header />
            <IonRow>
                <IonCol sizeXl='10' offsetXl='1' sizeLg='10' offsetLg='1' className='ion-padding bg-content'>
                    <div className='page-container'>
                        <div className='title-bar'>
                            <h6>Sub Category</h6>
                            <h1>{decodeURIComponent(subCat)}</h1>
                            {category && <IonButton fill='outline' routerLink={appSubDir + "categories/" + encodeURIComponent(cat)}><IonIcon icon={arrowUp} slot='start' />{category.title}</IonButton>}
                            {category && category.subCategories.length > 0 && <IonButton onClick={() => modal.current?.present()} fill='outline'>All Other Sub Categoies</IonButton>}
                        </div>
                        <ProductGridWithPagination keyword={subCat} />
                        {category && category.subCategories.length > 0 && <IonModal ref={modal}>
                            <IonHeader>
                                <IonToolbar>
                                    <IonTitle>Other Sub Categories</IonTitle>
                                    {window.screen.width > 425 && <IonButton onClick={() => modal.current?.dismiss()} slot='end' fill='clear'>Close</IonButton>}
                                </IonToolbar>
                            </IonHeader>
                            <IonContent>
                                {category.subCategories.filter((item) => (item !== subCat)).map((item, index) => <IonItem key={index} routerLink={appSubDir + "categories/" + encodeURIComponent(cat) + "/sub-categories/" + encodeURIComponent(item)} onClick={() => modal.current?.dismiss()}>{item}</IonItem>)}
                            </IonContent>
                            {window.screen.width <= 425 && <IonFooter>
                                <IonButton onClick={() => modal.current?.dismiss()} expand='block' fill='clear'>Close</IonButton>
                            </IonFooter>}
                        </IonModal>}
                    </div>
                </IonCol>
            </IonRow>
            <Footer />
        </IonContent>
    );
};

export default SubCategory;
